import { InputAdornment } from '@mui/material';
import React from 'react';

// Utility function for InputProps with custom end icon
export function getInputPropsWithEndIcon(params: any, icon: React.ReactNode) {
  const hasAdornment = !!params.InputProps?.endAdornment;
  return {
    ...params.InputProps,
    endAdornment: hasAdornment ? (
      params.InputProps?.endAdornment
    ) : (
      <InputAdornment position="end">{icon}</InputAdornment>
    ),
  };
}
